import { render, staticRenderFns } from "./SUS.vue?vue&type=template&id=7e94a6b5&scoped=true&"
import script from "./SUS.vue?vue&type=script&lang=js&"
export * from "./SUS.vue?vue&type=script&lang=js&"
import style0 from "./SUS.vue?vue&type=style&index=0&id=7e94a6b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e94a6b5",
  null
  
)

export default component.exports